import React from "react";
import styled from "styled-components";
import bgBS from "../../../images/bg_bancaSistem.jpg";
import BSWhite from "../../../images/banca_sistema_white_new.png";


const BSJumbo = () => {
  return (
    <JumboContainer>
      <LeftSide>
        <A href="https://bancasistema.it/" rel="noreferrer" target="_blank">
          <img
            src={BSWhite}
            alt="Banca Sistema Logo"
            style={{ maxWidth: "100%" }}
          />
        </A>
      </LeftSide>
      <RightSide>
        <AStyle $bgColor="#007fc8">
            <a href="https://bancasistema.it/factoring" rel="noreferrer" target="_blank">Factoring</a>
        </AStyle>
        <AStyle $bgColor="#005a9b">
            <a href="https://bancasistema.it/servizi-bancari" rel="noreferrer" target="_blank">Banking</a>
        </AStyle>
        <AStyle $bgColor="#000000">
            <a href="https://bancasistema.it/finanziamenti_retail" rel="noreferrer" target="_blank">Finanziamenti Retail</a>
        </AStyle>
      </RightSide>
    </JumboContainer>
  );
};

export default BSJumbo;

const A = styled.a`
  text-decoration: none;
  max-width: 420px;
  text-align: initial;
`

const JumboContainer = styled.div`
  background-image: url(${bgBS});
  background-position: center center;
  background-size: cover;
  padding-top: 6rem;
  padding-bottom: 6rem;
  margin-top: 6rem;
  display: flex;
  flex-wrap: wrap;
`;

const LeftSide = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  flex: 0 0 50%;
  max-width: 50%;
  @media (max-width: 768px) {
    max-width: 100%;
    flex: 0 0 100%;
    padding: 0 10px;
  }
`;

const RightSide = styled.div`
  flex: 0 0 50%;
  max-width: 50%;
  overflow: visible;
  @media (max-width: 768px) {
    margin-top: 100px;
    max-width: 100%;
    flex: 0 0 100%;
    place-items: center;
  }
`

const AStyle = styled.div<{ $bgColor?: string }>`
  position: relative;
  background: linear-gradient(to right, transparent 0%, ${({ $bgColor }) => $bgColor || '#007fc8'} 7%, ${({ $bgColor }) => $bgColor || '#007fc8'} 100%);
  text-align: initial;
  padding: 8px 20px;
  width: 100%;
  margin: 6rem 0;
  &::before {
    content: '';
    position: absolute;
    right: 170%;
    top: 0;
    height: 100%;
    width: 30%;
    background: linear-gradient(to left, transparent 30%, transparent 50%, ${({ $bgColor }) => $bgColor || '#007fc8'} 130%);
  }
  & > * {
    text-decoration: none;
    text-transform: uppercase;
    font-weight: 700;
    color: #ffffff;
    font-size: 2rem;
    padding-left: 15rem;
  }
  @media (max-width: 768px) {
    margin-top: 100px;
    width: 100%;
    text-align: center;
    background: ${({ $bgColor }) => $bgColor || '#007fc8'};
    padding-left: 0;
    &::before {
      display: none;
    }
    & > * {
      padding-left: 0;
    }
  }
`
;
